import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';

@Pipe({
    name: 'dateFormatPipe2',
    standalone: false
})
export class dateFormatPipe2 implements PipeTransform {
    transform(value: string, formatfrom:string, format: string) {
        
        var date = moment(value,formatfrom);
        
        //var datePipe = new DatePipe("pt-BR");
        value = date.format(format);
        
        return value;
    }
}